import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, LinkedInput, LinkedToggle, FlowTable, Modal } from 'components/basic'
import FlowView from 'components/core/FlowView'
import http from 'API/http'
import { notify } from 'helpers'
import { default as swal } from 'sweetalert2'
import { Installation } from 'config'
class Install extends FlowView {
  constructor (props) {
    super(props, 'Installation')
    this.state = {
      access: false,
      editable: false,
      verificationType: 1,
      searching: false,
      modal: false,
      fiberOutlet: undefined,
      searchQuery: '',
      manual: false,
      results: [],
      activating: false,
      activated: false
    }
  }
  componentWillReceiveProps (nextProps) {
    let modal = false
    let editable = false
    let tip = ''
    let verificationType = 1
    let manual = false
    let fiberOutletModal = false

    console.log(Installation)
    console.log(nextProps.access)

    if (Installation.enable.checkFiberOutlet) {
      fiberOutletModal = true
    }
    if (nextProps.access.accessId === null && Installation.enable.enterManually) {
      manual = true
      editable = true
      verificationType = 3
    }
    if (nextProps.access.accessId === null && Installation.enable.search) {
      modal = true
      tip = 'Search for Address'
    }
    if (!nextProps.access.streetName && !Installation.enable.search && !Installation.enable.enterManually) {
      return swal('', 'There is no Address registred for this address and manually entering an address has been disabled.', 'error').then(e => window.location.reload())
    }

    this.setState({
      access: nextProps.access,
      accessSwitch: nextProps.access.accessSwitch || 'Unspecified Switch',
      accessPort: nextProps.access.accessPort || 'Unspecified Port',
      modal: modal,
      tip: tip,
      editable: editable,
      verificationType: verificationType,
      manual: manual,
      fiberOutletModal: fiberOutletModal
    })
  }
  async searchAddress () {
    if (this.state.searchQuery.length < 3) return this.setState({searching: false, results: []})
    this.setState({searching: true})
    clearTimeout(this.state.search)
    this.state.search = setTimeout(async () => {
      var err, res
      [err, res] = await http.get('access/search/' + this.state.searchQuery)
      if (err) return this.setState({accesses: [], searching: false, results: []})
      this.setState({results: res.data || [], searching: false})
    }, 500)
  }
  getSaveButtonText () {
    switch (this.state.verificationType) {
      case 1:
        return Installation.phrase.saveIfExists
      case 2:
        return Installation.phrase.saveIfChanged
      case 3:
        return Installation.phrase.saveIfEmpty
      default:
        return Installation.phrase.saveIfExists
    }
  }
  async selectAddress (address) {
    if (address.verified) {
      var confirmed = await notify.confirm(address.accessSwitch + ' ' + address.accessPort, {title: 'This address is already connected to and verified at', confirmButtonColor: '#2ecc71', confirmButtonText: 'Update Connection', type: 'error'})
      if (!confirmed) return
    } else if (address.accessSwitch || address.accessPort) {
      var confirmed = await notify.confirm(address.accessSwitch + ' ' + address.accessPort, {title: 'This address is already connected to', confirmButtonColor: '#2ecc71', confirmButtonText: 'Update Connection'})
      if (!confirmed) return
    }
    this.setState({
      access: Object.assign(
        {},
        this.state.access,
        address,
        {
          accessPort: this.state.accessPort,
          accessSwitch: this.state.accessSwitch
        }
      ),
      manual: false,
      verificationType: 2,
      editable: false,
      modal: false,
      searchQuery: ''
    })
  }
  async verifyAddress () {
    this.setState({activating: true})
    var res, err
    if (this.state.access.accessId) {
      [err, res] = await http.post('access/' + this.state.access.accessId, this.state.access)
      if (err) return notify.alert('', res.cause, 'error')
      console.log(err, res)
      return this.setState({verifiedModal: true, activating: false, activated: true})
    }
    [err, res] = await http.put('access/', this.state.access)
    if (err) return notify.alert('', res.cause, 'error')
    console.log(err, res)
    this.setState({verifiedModal: true, activating: false})
  }
  render () {
    if (!this.state.access) return false
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Installation' subtitle={this.state.accessSwitch + ' - ' + this.state.accessPort} icon='fa-gear' />
        <div className='row'>
          <StaticBox title={this.state.accessSwitch + ' - ' + this.state.accessPort} icon='server' buttons={[
              { hidden: !Installation.enable.search || this.props.access.accessId, icon: 'fa-search', event: e => this.setState({modal: true}), tip: 'Search for Address' },
              { hidden: !Installation.enable.enterManually, icon: 'fa-plus', event: e => this.setState({editable: true, verificationType: 3, manual: true}), tip: 'Create new address' }
          ]}>
            <div className='row'>
              <div className='col-md-4'>
                <label>Street</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.streetName' />
              </div>
              <div className='col-md-1'>
                <label>Number</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.streetNumber' />
              </div>
              <div className='col-md-1'>
                <label>Litteral</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.streetLittera' />
              </div>
              <div className='col-md-2'>
                <label>Zipcode</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.postalCode' />
              </div>
              <div className='col-md-4'>
                <label>City</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.city' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <label>Apartment Number</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.mduApartmentNumber' />
              </div>
              <div className='col-md-3'>
                <label>Apartment Address</label>
                <LinkedInput context={this} editable={this.state.editable} path='access.mduDistinguisher' />
              </div>
              {Installation.enable.checkFiberOutlet &&
              <div className='col-md-2'>
                <label>Fiber Outlet</label>
                <LinkedToggle context={this} path='fiberOutlet' name='Fiber Outlet' />
              </div>}
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <hr />
              </div>
              <div className='col-md-6 text-left'>
                {this.state.access.accessId && <button className='btn btn-primary' onClick={e => this.setState({wrongAddressModal: true})}>This address is wrong</button>}
              </div>
              <div className='col-md-6 text-right'>
                {(!this.state.activating && !this.state.activated && (this.state.access.streetName || this.state.access.streetNumber || this.state.access.mduApartmentNumber || this.state.access.city)) && <button className='btn btn-success' onClick={e => this.verifyAddress()}>{this.getSaveButtonText()}</button>}
                {this.state.activating && <button className='btn btn-success'><i className='fa fa-spin fa-spinner' /></button>}
                {this.state.activated && <button className='btn btn-success'><i className='fa fa-check' /></button>}
              </div>
            </div>
          </StaticBox>
        </div>
        <Modal title='Search' icon={this.state.searching ? 'spinner fa-spin' : 'search'} isOpen={(this.state.fiberOutletModal === false && this.state.modal)} close={e => this.setState({modal: false })}
          buttons={[
              {text: 'Enter Manually', event: e => this.setState({manual: true, editable: true, verificationType: 3, modal: false}), hidden: (!Installation.enable.enterManually)}
          ]}>
          <div className='row'>
            <div className='col-md-12'>
              <LinkedInput context={this} placeholder='Search' path='searchQuery' onChange={e => this.searchAddress()} />
            <p className='help-block'><small className='margin-left-10'>You need to search for atleast 4 characters.</small></p>
              <hr />
            </div>
            <div className='col-md-12'>
              <FlowTable paginatable={5} data={this.state.results.map(res => [
                  { onClick: e => this.selectAddress(res) },
                  [<a className='table-link'><i className='fa fa-play' /> </a>, (res.accessSwitch || res.accessPort) ? <i className={'fa fa-chain' + (res.verified ? ' text-success' : '')} /> : <i className='fa fa-chain-broken' />],
                  `${res.streetName || ''} ${res.streetNumber || ''} ${res.streetLittera || ''}`,
                  `${res.mduApartmentNumber || ''} ${res.mduDistinguisher || ''}`,
                  `${res.postalCode} ${res.city}`])}>
                <tr>
                  <th />
                  <th>Street</th>
                  <th>Apartment</th>
                  <th>City</th>
                </tr>
              </FlowTable>
            </div>
          </div>
        </Modal>
        <Modal title='This address has been verified.' isOpen={this.state.verifiedModal} close={e => this.setState({verifiedModal: false})}>
          <div className='row' style={{marginTop: 20}}>
            <div className='col-xs-12 flexbox-absolute-center'>
              <div className='swal2-icon swal2-success swal2-animate-success-icon'>
                <div className='swal2-success-circular-line-left' />
                <span className='swal2-success-line-tip' />
                <span className='swal2-success-line-long' />
                <div className='swal2-success-ring' />
                <div className='swal2-success-fix' />
                <div className='swal2-success-circular-line-right' />
              </div>
            </div>
          </div>
          <div className='col-xs-12'>
            <div className='well'>
              <p><b>Port:</b> {this.state.access.accessPort}</p>
              <p><b>Switch:</b> {this.state.access.accessSwitch}</p>
              <p><b>Address:</b> {`${this.state.access.streetName || ''} ${this.state.access.streetNumber || ''} ${this.state.access.streetLittera || ''} ${this.state.access.mduApartmentNumber || ''} ${this.state.access.mduDistinguisher || ''}`}</p>
              <p><b>City:</b> {`${this.state.access.postalCode} ${this.state.access.city}`}</p>
            </div>
          </div>
          {Installation.enable.portalRedirectAfterInstallation && <div className='row' style={{marginTop: 20}}>
            <div className='col-xs-12 flexbox-absolute-center'>
              <a href={Installation.portalURL} className='btn btn btn-primary'>
                Visit consumer portal
              </a>
            </div>
          </div>}
        </Modal>
        <Modal title='Does this address have a Fiber Outlet?' isOpen={this.state.fiberOutletModal} close={e => this.setState({fiberOutletModal: false})}>
          <div className='row' style={{marginTop: 20}}>
            <div className='col-xs-6 flexbox-absolute-center'>
              <button onClick={e => this.setState({fiberOutletModal: false, fiberOutlet: true })} className='btn btn btn-success'>
                Fiber Outlet
              </button>
            </div>
            <div className='col-xs-6 flexbox-absolute-center'>
              <button onClick={e => this.setState({fiberOutletModal: false, fiberOutlet: false})} className='btn btn btn-danger'>
                <u>No</u> Fiber Outlet
              </button>
            </div>
          </div>
        </Modal>
        <Modal title='Wrong Address' isOpen={this.state.wrongAddressModal} close={e => this.setState({wrongAddressModal: false})}>
          <div className='row' style={{marginTop: 20}}>
            <div className='col-xs-12'>
              {ReactHtmlParser(Installation.phrase.wrongAddress)}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
Install = connect(state => state.siteReducer)(Install)
export default Install



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/views/installation/install.js